import {useRouter} from 'next/router';
import {useCallback} from 'react';
import {AppLinkFallbackType} from '../../../applink/AppLinkFallbackType.enum';
import {pagewebUrlMatcher} from '../../../applink/PagewebUrlMatcher.singleton';
import {requestContext} from '../../../common/requestContext';
import {
  APP_DONWLOAD_PAGE_TRY_SCHEME_PARAM_KEY,
  APP_DOWNLOAD_PAGE_TRY_URL_PARAM_KEY,
} from '../../../common/shared/constants';
import {NotAvailableOnWeb} from '../../../design-system/organisms/NotAvailableOnWeb/NotAvailableOnWeb';
import {MetaHead} from '../../../meta/MetaHead';
import {PAGE_SCHEME_ACTION_URL_PARAM_KEY} from '../../bridge/applink/constant';

export function AppDownloadContainer() {
  const router = useRouter();

  const onClickAppDownload = useCallback(() => {
    let appLinkUrl;

    // 앱링크 처리 시 pscme 정보를 이미 붙여준 경우입니다.
    if (router.query[PAGE_SCHEME_ACTION_URL_PARAM_KEY]) {
      appLinkUrl = pagewebUrlMatcher.getAppLinkByScheme({
        scheme: decodeURIComponent(
          router.query[PAGE_SCHEME_ACTION_URL_PARAM_KEY] as string
        ),
        fallbackType: AppLinkFallbackType.Store,
      });
    }
    // 앱으로 가기 버튼을 눌렀을 때 실행할 앱링크에 대응하는 Path Query가 존재하는 경우입니다.
    else if (router.query[APP_DOWNLOAD_PAGE_TRY_URL_PARAM_KEY]) {
      appLinkUrl = pagewebUrlMatcher.getAppLinkByPathQuery({
        pathQuery: decodeURIComponent(
          router.query[APP_DOWNLOAD_PAGE_TRY_URL_PARAM_KEY] as string
        ),
        schemePrefixType: 'applink',
        fallbackType: AppLinkFallbackType.Store,
      });
    }
    // 앱으로 가기 버튼을 눌렀을 때 실행할 앱링크에 대응되는 스킴이 존재하는 경우입니다.
    else if (router.query[APP_DONWLOAD_PAGE_TRY_SCHEME_PARAM_KEY]) {
      appLinkUrl = pagewebUrlMatcher.getAppLinkByScheme({
        scheme: decodeURIComponent(
          router.query[APP_DONWLOAD_PAGE_TRY_SCHEME_PARAM_KEY] as string
        ),
        fallbackType: AppLinkFallbackType.Store,
      });
    } else {
      appLinkUrl = pagewebUrlMatcher.getDefaultAppLink({
        schemePrefixType: 'applink',
        fallbackType: AppLinkFallbackType.Store,
      });
    }

    window.location.assign(appLinkUrl);
  }, [router]);

  return (
    <>
      <NotAvailableOnWeb
        onClickAppLink={onClickAppDownload}
        isMobile={requestContext?.requestInfo?.display?.isMobile ?? true}
      />
      <MetaHead
        metaInfo={{
          title: '앱설치 안내',
          ogTitle: '앱설치 안내 | 카카오페이지',
        }}
      />
    </>
  );
}
